module.exports = __webpack_public_path__ + "img/en-ico.a2f8d13a.svg";